import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popup-body-message text-text-default" }
const _hoisted_2 = { class: "comment-to-delete-preview" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "posted-user-comment" }

import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { Portal } from 'portal-vue';
import { useConfirmDialog } from '@vueuse/core';
import CommentPostedByRow from '@/components/widgets/CommentPostedByRow';
import CommentListItemDescriptionRow from '@/components/widgets/CommentListItemDescriptionRow';
import UserAvatar from '@/components/widgets/UserAvatar';
import EventBus from '@/utilities/eventBus';
import styleVariables from '@/assets/scss/variables.module.scss';
import ConfirmationModal from '@/components/widgets/ConfirmationModal.vue';
import { ResourceType } from '@/types/resources';
import cloneDeep from 'lodash/cloneDeep';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'PopUpDeleteComment',
  setup(__props) {

const opsScroll = ref({
  scrollPanel: {
    scrollingX: false,
  },
  bar: {
    background: styleVariables.gray200,
    keepShow: true,
  },
  rail: { gutterOfEnds: '8px' },
});
const confirmDialog = useConfirmDialog();
const _this = getCurrentInstance()!.proxy as any;
const modal = computed(() => _this.$store.getters.getModal);
const { translate } = useTranslate();

const cardId = computed(() => modal.value.meta?.card_id || '');
const cardTotalComments = computed(
  () => _this.$store.getters.getCardById(cardId.value).total_comments || 0
);
const owner = computed(() => _this.$store.getters.getMemberById(comment.value.user_id));

const commentId = computed(() => modal.value.resource_id);
const commentParentId = computed(() => modal.value.meta?.parent_id || '');
const commentType = computed(() => modal.value.resource_type || '');
const comment = computed(() => {
  if (commentParentId.value) {
    const parentComment = _this.$store.getters.getCommentById(commentParentId.value, cardId.value);
    if ((((parentComment || {}).children || {}).child_comments || []).length) {
      const comment = parentComment.children.child_comments.find(
        (c: any) => c.id === commentId.value
      );
      return comment || {};
    }
    return parentComment;
  }
  return _this.$store.getters.getCommentById(commentId.value, cardId.value);
});

onMounted(() => {
  confirmDialog.reveal();
});

const deleteComment = () => {
  if (_this.$route.name !== 'page' && !comment.value?.parent_id) {
    _this.$store.dispatch('updateCardTotalCommentsCount', {
      cardId: cardId.value,
      currentCommentsCount: cardTotalComments.value,
      decrease: true,
    });
  }
  // modal will close before we delete comment so we need to
  // make deep copy of the object to avoid mutation of props when it does close
  const payload = cloneDeep({
    commentId: commentId.value,
    commentType: commentType.value,
    ...(commentType.value === ResourceType.CardComment && { cardId: cardId.value }),
    parentCommentId: commentParentId.value,
  });

  hidePopUp();

  return _this.$store
    .dispatch('deleteComment', payload)
    .then(() => {
      if (_this.$route.name === 'page') {
        EventBus.$emit('removePageComment', payload.commentId);
        _this.$store.dispatch('setActiveComment', '');
      }
    })
    .catch((/* error */) => {
      if (_this.$route.name !== 'page') {
        _this.$store.dispatch('updateCardTotalCommentsCount', {
          cardId: payload.cardId,
          currentCommentsCount: cardTotalComments.value,
        });
      }
      _this.$store.dispatch('setPopUpMessage', _this.translate('couldntDeleteComment'));
    });
};

const hidePopUp = () => {
  _this.$store.dispatch('setModal', {});
};

return (_ctx: any,_cache: any) => {
  const _component_vue_scroll = _resolveComponent("vue-scroll")!

  return (_unref(confirmDialog).isRevealed.value)
    ? (_openBlock(), _createBlock(_unref(Portal), {
        key: 0,
        to: "root-widget"
      }, {
        default: _withCtx(() => [
          _createVNode(ConfirmationModal, {
            class: "delete-comment-popup",
            title: _unref(translate)('deleteMessage'),
            "confirm-button-text": _unref(translate)('delete'),
            "width-class": 'w-[80%] md:w-[35%]',
            "confirm-button-type": 'popup-button-wrap delete',
            "cancel-button-type": 'popup-button-wrap secondary',
            "button-classes": '',
            "button-wrap-class": 'justify-end',
            onConfirm: deleteComment,
            onCancel: hidePopUp
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("strong", null, _toDisplayString(_unref(translate)('deleteCommentPopupMessage')), 1),
                _createTextVNode(" " + _toDisplayString(_unref(translate)('cantUndoneAction')), 1)
              ]),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(), _createBlock(_unref(UserAvatar), {
                    key: comment.value.user_id,
                    member: owner.value
                  }, null, 8, ["member"])),
                  _cache[0] || (_cache[0] = _createTextVNode()),
                  _createVNode(_unref(CommentPostedByRow), { comment: comment.value }, null, 8, ["comment"])
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(_component_vue_scroll, {
                  ops: opsScroll.value,
                  class: "delete-comment-popup-body"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(CommentListItemDescriptionRow), { comment: comment.value }, null, 8, ["comment"])
                    ])
                  ]),
                  _: 1
                }, 8, ["ops"])
              ])
            ]),
            _: 1
          }, 8, ["title", "confirm-button-text"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})